import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { userPreferencesService, UserPreferences } from '@/services/userPreferencesService';

export const userPreferencesKeys = {
  all: ['userPreferences'] as const,
};

export function useUserPreferencesQuery() {
  return useQuery({
    queryKey: userPreferencesKeys.all,
    queryFn: () => userPreferencesService.get(),
    staleTime: Infinity,
  });
}

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (settings: Partial<Record<string, string>>) =>
      userPreferencesService.update(settings),
    onMutate: async (settings) => {
      await queryClient.cancelQueries({ queryKey: userPreferencesKeys.all });

      const previous = queryClient.getQueryData<UserPreferences>(userPreferencesKeys.all);

      queryClient.setQueryData<UserPreferences>(userPreferencesKeys.all, (old) =>
        old ? { ...old, ...settings } as UserPreferences : old,
      );

      return { previous };
    },
    onError: (_err, _vars, context) => {
      if (context?.previous) {
        queryClient.setQueryData(userPreferencesKeys.all, context.previous);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: userPreferencesKeys.all });
    },
  });
}
